import { Stack, Button } from "@mui/material";
import { ExitToApp } from "@mui/icons-material";

const TopBarLinks = (props) => {
  return (
    <Stack direction={"row"} spacing={3}>
      <Button
        variant="contained"
        disableElevation
        onClick={props.signout}
        color="error"
        startIcon={<ExitToApp />}
      >
        Logout
      </Button>
    </Stack>
  );
};

export default TopBarLinks;
